import * as React from "react";
import { Paper, Box } from "@mui/material";
import type { IEnvironment } from "../../../types/EnvironmentTypes";
import { EnvironmentPipeline } from "./EnvironmentPipeline";

export interface PipelineTabPanelProps {
  environments: IEnvironment[];
  selectedItem: IEnvironment | undefined;
  setSelectedItem: React.Dispatch<React.SetStateAction<IEnvironment | undefined>>;
  onLinkClick?: (srcEnvironment: IEnvironment, dstEnvironment: IEnvironment) => void;
}

export const PipelineTabPanel = ({ environments, selectedItem, setSelectedItem, onLinkClick }: PipelineTabPanelProps) => {
  const handleEnvironmentClick = (environment: IEnvironment) => {
    setSelectedItem(environment);
  };

  return (
    <Box
      sx={{
        width: "calc(100vw - 180px)",
        height: "calc(100vh - 180px)",
        mt: 2,
      }}
    >
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 2,
        }}
      >
        <EnvironmentPipeline
          environments={environments}
          onEnvironmentClick={handleEnvironmentClick}
          selectedItem={selectedItem}
          onLinkClick={onLinkClick}
        />
      </Paper>
    </Box>
  );
};
